import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "student-list-container" }
const _hoisted_2 = { class: "student-table" }

import {onMounted, ref} from 'vue'
import {ApiMap} from "@/api/type";
import {useApi} from "@/api/handler";
import {classes} from "@/api";


export default /*@__PURE__*/_defineComponent({
  __name: 'StudentList',
  props: {
    cid: {},
    loading: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props

const studentList = ref<ApiMap['/class/student/list']['resp']['list'] | null>(null)
const headers = [{ title: 'ID', key: 'id', align: 'begin' }, { title: '学号', key: 'sno', align: 'begin' }, { title: '名称', key: 'name', align: 'begin' }]

const selectedStudent = ref<Array<number> | null>(null)
const pageSize = ref<number>(10)
const pageNum = ref<number>(1)
const totalNum = ref<number>(0)
const keyWord = ref<string>('')

onMounted(() => {
  useStudentList()
})

function exposedStudentList(key: string) {
  keyWord.value = key
  useStudentList()
}

const useStudentList = () => {
  useApi({
    api: classes.StudentList(props.cid, pageNum.value, pageSize.value, keyWord.value),
    onSuccess: resp => {
      const data = resp.data as ApiMap['/class/student/list']['resp']
      totalNum.value = data.total
      studentList.value = data.list
    }
  })
}

const useDeleteStudent = () => {
  if (!selectedStudent.value) return
  useApi({
    api: classes.DeleteStudent(selectedStudent.value),
    onSuccess: () => {
      useStudentList()
      selectedStudent.value = []
    },
    tip: '删除成功'
  })
}

__expose({ exposedStudentList })

return (_ctx: any,_cache: any) => {
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "w-100 bg-indigo-lighten-2 text-h6 pl-6 py-4" }, "学生列表", -1)),
    _createElementVNode("div", _hoisted_2, [
      (studentList.value)
        ? (_openBlock(), _createBlock(_component_v_data_table_server, {
            key: 0,
            headers: headers,
            modelValue: selectedStudent.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedStudent).value = $event)),
            "show-select": "",
            items: studentList.value,
            "items-per-page": pageSize.value,
            "onUpdate:itemsPerPage": _cache[1] || (_cache[1] = ($event: any) => ((pageSize).value = $event)),
            page: pageNum.value,
            "onUpdate:page": _cache[2] || (_cache[2] = ($event: any) => ((pageNum).value = $event)),
            "items-length": totalNum.value,
            "no-data-text": "该班级尚未导入学生",
            density: "comfortable",
            "items-per-page-text": "每页展示：",
            "page-text": `第 ${pageNum.value} 页，共 ${totalNum.value} 名`,
            "onUpdate:options": useStudentList,
            loading: _ctx.loading,
            hover: ""
          }, null, 8, ["modelValue", "items", "items-per-page", "page", "items-length", "page-text", "loading"]))
        : _createCommentVNode("", true),
      (selectedStudent.value && Object.keys(selectedStudent.value).length > 0)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 1,
            color: "red-lighten-2",
            class: "ml-6 delete-button",
            onClick: useDeleteStudent
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("删除")
            ])),
            _: 1,
            __: [3]
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})